import { createQuery } from '@luna/api';
import { ConfigurationsService } from '@api-client/payments';

export const [
    useCountries,
    { queryApiIfNeeded: fetchCountriesIfNeeded, selectData: selectCountries },
] = createQuery({
    name: 'info/countries',
    payloadCreator: async () => {
        const response = await ConfigurationsService.getSupportedCountries({
            order: 'MOST_USED_ASC',
        });

        return response.countries;
    },
});
